<template>
<div>
  <div v-if="canAdd">
    <button v-if="productMainView == 'cartactions'" class="cta-btn cta-btn-sm" @click="addToCart" style="width:50vw;"> {{productMain.product_cta_name || ' Buy Now'}}</button>
    <button  v-else class="cta-btn" @click="addToCart" style="width:50vw;"> {{productMain.product_cta_name || ' Buy Now'}}</button>
   </div>
   <div v-else>
    <button class="cta-btn" @click="redir(productMain.product_business_ownername)" style="width:50vw; text-align:left; padding-left:5px; font-size:14px;"> Continue Shopping</button>
   </div>
</div>
</template>
<style>
 /* .cart-btn{
  border: none;
	border-radius: 50px;
	box-shadow: none;
	white-space: nowrap;
	color: #fff;
	padding: 10px 10px;
	font-size: 12px;
	font-family: 'Montserrat', sans-serif;
	background: #2d3a4b;
	letter-spacing: 1px;
	position: relative;
	text-align: center;
	z-index: 1;
 } */
 .cta-btn-sm{
  /* padding:3px; */
  /* line-height: 1.2; */
  font-size: 12px;
}
  .cta-btn{
    width: 100%;
    border: none;
    /* border-radius: 3px; */
    box-shadow: none;
    white-space: nowrap;
    color: #ffffff;
    padding: 10px 40px;
    font-size: 16px;
    font-family: 'Montserrat', sans-serif;
    /* background: #fd9729; */
    background: #fc4112;
    /* background: #339900; */
    letter-spacing: 1px;
    position: relative;
    text-align: center;
    z-index: 1;
  }
  @media only screen 
  and (min-device-width: 320px) 
  and (max-device-width: 640px){
    .cta-btn{
      padding: 10px 10px;
      font-size: 16px;
      
    }
  }
</style>
<script>
  import {
    ADD_TO_CART,
    REMOVE_FROM_CART
  } from '../../store/mutation-types'
  import services from './../../services/service'; // Service Class
  let service = new services();
  export default {
    props: ['productMain','productItemGroup','productItem','productMainView'],
    data () {
      return {
        user:{},
        cart: this.$store.state.cart
      }
    },
    computed: {
      canAdd () {
        // return this.cart.indexOf(this.productItem) < 0
        const index = this.cart.findIndex(p => p.product_item_id === this.productItem.product_item_id) //best removal
        if(index < 0){
          return true;
        }
        
      }
    },
    methods: {
     
      addToCart () {
        this.productItem.active_order = true;
        this.productItem._id = this.productItem.product_item_id;
        //config qty if not set
        if(this.productItem.product_item_order_quantity == undefined){
          this.productItem.product_item_order_quantity = 1;
        }
        this.productItem.product_main_id = this.productMain.product_id;
        this.productItem.product_business_name = this.productMain.product_business_name;
        this.productItem.product_business = this.productMain.product_business_ownername;
        this.productItem.product_name = this.productMain.product_name;
        this.productItem.product_order_url = this.productMain.product_business_ownername+"-"+this.productMain.product_url_name;
        this.productItem.product_url = this.productMain.product_business_ownername+"/"+this.productMain.product_url_name;
        this.productItem.product_item_quantity = this.productItem.product_item_quantity;
        //some settings 
        //for product items images
        if((this.productItemGroup.product_item_group_is_color_image == 'IMG') && (this.productItemGroup.product_item_group_image != 'error')){
          this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
        }else{ //is color or error
          this.productItem.product_item_image = '';
        }
        //for product_shipping_calculation_method
        this.productItem.product_shipping_calculation_method = this.productMain.product_set_shipping_fee_status;
        //../some settings 

        //some additional settings for cart circle to avoid mutation errors
        this.productItem.can_remove = true; //for removal when not selected for checkout at cart
        
        //cart sorting settings
        this.productItem.product_business_sort = this.productMain.product_business_ownername;

        //agent settings
        this.productItem.product_referral_bash = "";
        this.productItem.product_has_referral_bash = 0;
        let product_ref = "REF-"+this.productMain.product_url_name;
        let ref_check = localStorage.getItem(product_ref);
        if(ref_check && ((ref_check != null) || (ref_check != ''))){
          this.productItem.product_has_referral_bash = 1;
          this.productItem.product_referral_bash = ref_check;
        }
        //

        //check product referral
        if(this.productMain.product_agent_ship.product_business_is_agent == 1){
          this.productItem.product_is_from_agent = this.productMain.product_agent_ship.product_business_is_agent;
          this.productItem.product_business_agent_name = this.productMain.product_agent_ship.product_business_agent_name;
          this.productItem.product_business_agent_username = this.productMain.product_agent_ship.product_business_agent_username;
          this.productItem.product_business_sort = this.productMain.product_agent_ship.product_business_agent_username;
        }
        //.../agent settings
        
        //service subscription update settings
        if(localStorage.getItem("product_sub")){
          let sub_check = localStorage.getItem("product_sub");
          if(sub_check && ((sub_check != null) || (sub_check != undefined) || (sub_check != ''))){
            this.productItem.product_is_updated_subscription = 1;
            this.productItem.product_current_subscription = sub_check;
          }
        }
        //../
        //

        this.$store.commit(ADD_TO_CART, this.productItem);

        this.redir('order');//push to order
      },
      // removeFromCart (id) {
      //   this.$store.commit(REMOVE_FROM_CART, id)
      // },
      removeFromCart (payload) {
        this.$store.commit(REMOVE_FROM_CART, payload)
      },
      redir(rlink){
        location.replace("/"+rlink)
      },
      configureCTAButton(){

      },      
    },
    created: function(){
        if(this.productMain.product_cta_name && (this.productMain.product_cta_name == 'error')){
          this.productMain.product_cta_name = "Buy Now";
        }
    }
  }
</script>



// WEBPACK FOOTER //
// ProductCTAActions.vue?604c173c